__turbopack_context__.v({
  "passport_donate_button": "_23xEtq_passport_donate_button",
});
